import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { Button } from '@design-system/button';
import { CATEGORIES, FontAwesomeIconWithBackground, } from '@design-system/font-awesome-icon';
const DEFAULT_BUTTON_PROPS = {
    size: 'normal',
};
const DEFAULT_FA_PROPS = {
    bg: true,
    color: 'primary',
    height: '72px',
    iconType: CATEGORIES.DUOTONE,
};
const ActionButton = ({ buttonComponent: ButtonComponent, buttonProps, }) => {
    if (ButtonComponent) {
        return (_jsx(Box, { mt: 5, children: _jsx(ButtonComponent, {}) }));
    }
    const computedButtonProps = buttonProps
        ? Object.assign(Object.assign({}, DEFAULT_BUTTON_PROPS), buttonProps) : null;
    const _a = computedButtonProps !== null && computedButtonProps !== void 0 ? computedButtonProps : {}, { children: buttonChildren } = _a, otherButtonProps = __rest(_a, ["children"]);
    if (!computedButtonProps) {
        return null;
    }
    return (_jsx(Box, { mt: 5, children: _jsx(Button, Object.assign({}, otherButtonProps, { size: buttonProps && buttonProps.size, children: buttonChildren })) }));
};
export const EmptyStateWithoutCard = ({ buttonComponent, buttonProps, description, faIconProps, title, }) => {
    const computedFaProps = faIconProps
        ? Object.assign(Object.assign({}, DEFAULT_FA_PROPS), faIconProps) : null;
    return (_jsx(Box, { alignItems: "center", height: "100%", justifyContent: "center", children: _jsxs(Box, { alignItems: "center", flexDirection: "column", children: [computedFaProps && (_jsx(Box, { mb: 5, children: _jsx(FontAwesomeIconWithBackground, Object.assign({}, computedFaProps)) })), title && (_jsx(Box, { font: "h3-semibold", textAlign: "center", children: title })), description && (_jsx(Box, { font: "h4-regular", mt: 1, textAlign: "center", children: description })), _jsx(ActionButton, { buttonComponent: buttonComponent, buttonProps: buttonProps })] }) }));
};
//# sourceMappingURL=EmptyStateWithoutCard.js.map